/**
 * Trigger: tr_debtor_payments_delete
 * Purpose: Update account balances and debtor totals when a debtor payment is hard deleted
 * Table: debtor_payments
 * Event: BEFORE DELETE
 */
export const TR_DEBTOR_PAYMENTS_DELETE = `
CREATE TRIGGER tr_debtor_payments_delete
BEFORE DELETE ON debtor_payments FOR EACH ROW
BEGIN
  UPDATE account_balances
  SET debtor_payments_amount = debtor_payments_amount - old.amount
  WHERE old.is_deleted = 0
    AND account_id = (SELECT account_id FROM debtors WHERE _id = old.debtor_id)
    AND currency_id = old.currency_id;

  UPDATE account_daily_balances
  SET debtor_payments_amount = debtor_payments_amount - old.amount
  WHERE old.is_deleted = 0
    AND account_id = old.account_id
    AND currency_id = old.currency_id
    AND balance_date = old.payment_date;

  UPDATE debtors
  SET total_amount = total_amount - old.amount
  WHERE old.is_deleted = 0
    AND _id = old.debtor_id;

  DELETE FROM account_daily_balances
  WHERE account_id = old.account_id
    AND expenses_amount = 0
    AND incomes_amount = 0
    AND debtors_amount = 0
    AND creditors_amount = 0
    AND debtor_payments_amount = 0
    AND creditor_payments_amount = 0
    AND transfers_amount = 0
    AND exchanges_amount = 0
    AND initial_balance = 0;

  DELETE FROM account_activity_dates
  WHERE account_id = old.account_id
    AND NOT EXISTS (
    SELECT _id FROM account_daily_balances
    WHERE account_daily_balances.account_id = account_activity_dates.account_id
      AND account_daily_balances.balance_date = account_activity_dates.activity_date
  );
END;
`;
